export default {"wrapper":"_wrapper_kkqmx_1"};